import { render, staticRenderFns } from "./SaveEmailTemplateBtn.vue?vue&type=template&id=11dc8d42&scoped=true&"
import script from "./SaveEmailTemplateBtn.vue?vue&type=script&lang=js&"
export * from "./SaveEmailTemplateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dc8d42",
  null
  
)

export default component.exports